import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/classes/$classId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/classes/$classId/block/$blockIdx',
      params: {
        classId: params.classId,
        blockIdx: '0',
      },
    });
  },
  component: () => null,
});
